import { Head } from "@inertiajs/react";
import { t } from "@travily/i18n";
import { creatorListingsPath, productCreatorStagePath } from "@travily/routes";
import type ListingsCreatorTagline from "@travily/types/pages/ListingsCreatorTagline";
import { useCreatorTopBarActions } from "@/lib/wizard/use-creator-top-bar-actions";
import { useWizardForm } from "@/lib/wizard/use-wizard-form";
import { ProductTaglineStepView } from "./show.view";

type PageProps = ListingsCreatorTagline;

type FormData = {
  tagline: string;
};

const ProductTaglineStep = ({ listing_id, stage_index, stage_order, tagline }: PageProps) => {
  const { bindField, currentStage, totalStages, onBack, onPrimary, onEnterSubmit, primaryPending } =
    useWizardForm<FormData>({
      routes: {
        stageUrl: (stage) => productCreatorStagePath(listing_id, stage),
        entryUrl: creatorListingsPath(),
      },
      stageName: "tagline",
      stageIndex: stage_index,
      stageOrder: stage_order,
      initialData: { tagline: tagline ?? "" },
    });
  const taglineField = bindField("tagline", { validateOn: "change" });

  const topBarActions = useCreatorTopBarActions({ saveHref: creatorListingsPath() });

  return (
    <>
      <Head title={t("web.products.creator.steps.tagline.show.meta_title")}>
        <meta name="description" content={t("web.products.creator.steps.tagline.show.meta_description")} />
      </Head>
      <ProductTaglineStepView
        currentStage={currentStage}
        totalStages={totalStages}
        onBack={onBack}
        topBarActions={topBarActions}
        onPrimary={onPrimary}
        primaryPending={primaryPending}
        error={taglineField.errorMessage}
        tagline={taglineField.value}
        onTaglineChange={taglineField.onChange}
        onTaglineBlur={taglineField.onBlur}
        onTaglineKeyDown={onEnterSubmit}
      />
    </>
  );
};

export default ProductTaglineStep;
